<template>
    <div>
        <div class="row">
            <div class="col-md-6 d-md-flex align-items-baseline">
                <h1 class="mr-2">List of Taxes</h1>
            </div>
            <div class="col-md-6 pb-3">
                <input-search-icon
                    @search="handleSearch"
                    placeholder="Search Name, Jurisdiction"
                    :debouncetime="500"
                >
                    <template v-slot:after>
                        <button
                            type="button"
                            class="btn btn-secondary ml-1"
                            v-b-tooltip.hover.top
                            title="New Tax"
                            @click="configTax(null, 'Create')"
                        >
                            <span class="fas fa-plus"></span>
                        </button>
                    </template>
                </input-search-icon>
            </div>
        </div>

        <div class="card rounded-lg p-3">
            <div class="card-body p-0" :class="{ 'overflow-auto': !isLoading }">
                <div class="table-holder table-responsive">
                    <LoaderList v-if="isLoading" class="w-100" />
                    <table
                        v-else
                        class="table list"
                        :class="{
                            'table-hover': list.length > 0
                        }"
                    >
                        <thead>
                            <tr>
                                <th>
                                    <sorting
                                        text="Name:"
                                        :order-by="orderBy('name')"
                                        @sorting="val => sort(val, 'name')"
                                    >
                                    </sorting>
                                </th>
                                <th>
                                    <sorting
                                        text="Value:"
                                        :order-by="orderBy('value')"
                                        @sorting="val => sort(val, 'value')"
                                    >
                                    </sorting>
                                </th>
                                <th>
                                    <sorting
                                        text="Type:"
                                        :order-by="orderBy('type')"
                                        @sorting="val => sort(val, 'type')"
                                    >
                                    </sorting>
                                </th>
                                <th>
                                    <sorting
                                        text="Jurisdiction:"
                                        :order-by="orderBy('jurisdiction')"
                                        @sorting="
                                            val => sort(val, 'jurisdiction')
                                        "
                                    >
                                    </sorting>
                                </th>
                                <th>Applies To:</th>
                                <th>
                                    <sorting
                                        text="Last Updated:"
                                        :order-by="orderBy('update_at')"
                                        @sorting="val => sort(val, 'update_at')"
                                    >
                                    </sorting>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="list.length > 0">
                            <tr v-for="item in list" :key="item.id">
                                <td>{{ item.name }}</td>
                                <td>{{ item.value }}%</td>
                                <td>{{ item.type_value }}</td>
                                <td>{{ item.jurisdiction }}</td>
                                <td>{{ appliesToLabel(item) }}</td>
                                <td>
                                    {{ _carbonDateDisplay(item.update_at) }}
                                </td>
                                <td class="text-right small text-nowrap">
                                    <span
                                        class="cursor-pointer"
                                        @click="configTax(item, 'Update')"
                                    >
                                        Edit
                                    </span>
                                    <span class="mx-1">|</span>
                                    <span
                                        class="cursor-pointer"
                                        @click="configTax(item, 'Delete')"
                                    >
                                        Delete
                                    </span>
                                </td>
                            </tr>
                        </tbody>

                        <tbody v-else>
                            <tr>
                                <td colspan="7">
                                    <i>No records available</i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <b-pagination
                class="vet-pagination mt-0 mb-0"
                align="right"
                v-model="currentPage"
                :total-rows="totalRecords"
                :per-page="perPage"
                prev-text="Prev"
                next-text="Next"
                first-text="First"
                last-text="Last"
                @change="value => fetchList({ page: value })"
            />
        </div>
        <modal-config-tax ref="configTaxModal" @reload="fetchList" />
    </div>
</template>

<script>
import InputSearchIcon from "@/module/commons/input-search-icon.vue";
import LoaderList from "@/components/elements/loader-list.vue";
import Sorting from "@/module/commons/sorting.vue";
import ModalConfigTax from "@/module/settings/taxes/modal-config-tax.vue";
export default {
    components: {
        InputSearchIcon,
        LoaderList,
        Sorting,
        ModalConfigTax
    },
    data() {
        return {
            isLoading: false,
            search: "",
            sorting: {
                column: "name",
                order: "asc"
            },
            list: [],
            currentPage: 1,
            perPage: 15,
            totalRecords: 0
        };
    },
    async mounted() {
        this.fetchList();
    },
    methods: {
        async fetchList(param = {}) {
            this.isLoading = true;

            let search = {};
            if (this.search && this.search !== "") {
                search = {
                    search: this.search
                };
            }

            let sortOption = {};
            if (this.sorting.column !== "") {
                sortOption = {
                    sortColumn: param.sort || this.sorting.column,
                    sortDirection: param.order || this.sorting.order
                };
            }

            const params = {
                perPage: this.perPage,
                page: param.page || this.currentPage,
                ...search,
                ...sortOption
            };

            const res = await this.$http.get(
                `${process.env.BARRAMUNDI}account/taxes`,
                {
                    params
                }
            );

            this.isLoading = false;
            this.list = res?.data?.response?.resources?.data || [];
            this.totalRecords =
                res?.data?.response?.resources?.meta?.total || 1;
        },
        appliesToLabel(record) {
            if (record.all_category === 1) {
                return "All Categories";
            } else {
                return record.applies_to;
            }
        },
        handleSearch(keyword = "") {
            this.search = keyword;
            this.currentPage = 1;

            this.fetchList({ page: 1 });
        },
        orderBy(column) {
            if (this.sorting.column === column) {
                return this.sorting.order;
            }
            return null;
        },
        sort(value, column) {
            this.sorting = {
                column: column,
                order: value
            };

            this.fetchList({
                order: value,
                sort: column
            });
        },
        configTax(data, type) {
            let tax = null;
            if (type != "Create") {
                tax = JSON.parse(JSON.stringify(data));
            }

            this.$refs.configTaxModal.open(type, tax);
        }
    }
};
</script>
